exports = module.exports = require("../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".j-editable-image[data-v-6086ab8d] {\n  height: 32px;\n  max-width: 100px !important;\n  cursor: pointer;\n}\n.j-editable-image[data-v-6086ab8d]:hover {\n  opacity: 0.8;\n}\n.j-editable-image[data-v-6086ab8d]:active {\n  opacity: 0.6;\n}\n", ""]);

// exports
